"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Flowchart___StyledSvg",
  componentId: "n2eu4n-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function Flowchart(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M410 409h-85v-63h85v63zm-254 0H71v-63h85v63zm42-338h85v63h-85V71zm232.848 232.95h-42.304V282.8c0-34.982-28.45-63.45-63.414-63.45h-63.457v-42.3h42.304c11.676 0 21.153-9.475 21.153-21.15V50.15c0-11.675-9.477-21.15-21.153-21.15H177.065c-11.676 0-21.152 9.475-21.152 21.15V155.9c0 11.675 9.476 21.15 21.152 21.15h42.304v42.3h-63.456c-34.986 0-63.457 28.468-63.457 63.45v21.15H50.152C38.476 303.95 29 313.425 29 325.1v105.75C29 442.525 38.476 452 50.152 452h126.913c11.676 0 21.152-9.475 21.152-21.15V325.1c0-11.675-9.476-21.15-21.152-21.15H134.76V282.8c0-11.654 9.497-21.15 21.152-21.15H325.13c11.633 0 21.11 9.496 21.11 21.15v21.15h-42.263c-11.675 0-21.152 9.475-21.152 21.15v105.75c0 11.675 9.477 21.15 21.152 21.15h126.87c11.677 0 21.153-9.475 21.153-21.15V325.1c0-11.675-9.476-21.15-21.152-21.15z"
  }));
}

var _default = Flowchart;
exports["default"] = _default;